export enum EventType {
	ScreenView = "screen_view",
	Purchased = "purchased",
	Rented = "rented",
	Redeemed = "redeemed",
	Played = "played",
	Search = "search",
	SearchResults = "search_results",
	Login = "login",
	Logout = "logout",
	CreateAccount = "create_account",
}
